import { TITLE_OPTIONS } from 'components/Home/data';
import { RHFControl, RHFSelect } from 'components/common/form';
import { useState, useEffect, useMemo } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import DonorGroupModal from './DonorGroupModal';
import PropTypes from 'prop-types';
import { useDonorCategories, useBranchStaff } from 'hooks/useDonors';
import useBranchPermission from 'hooks/useBranchPermission';
import ReactSelect from 'react-select';

const NameInputs = ({
  selectedDonorCategoryId,
  setDonorCategoryId,
  selectedDonorType,
  setSelectedDonorType
}) => {
  const { categories } = useDonorCategories();
  const { branchId } = useBranchPermission();
  const { staff } = useBranchStaff(branchId);

  const staffOptions = useMemo(
    () =>
      staff?.map(s => ({
        label: `${s.user?.first_name || ''} ${s.user?.last_name || ''}`.trim(),
        value: s.user?.id
      })).filter(s => s.value) || [],
    [staff]
  );

  const donorTypesOptions = [
    { value: 'individual', label: 'Individual' },
    { value: 'organisation', label: 'Organisation' }
  ];

  const donorGroupOptions = categories?.map(({ id, title }) => ({
    value: id,
    label: title
  }));

  const [showCategoryModal, setShowCategoryModal] = useState(false);

  const openModal = () => {
    setShowCategoryModal(true);
  };

  const closeModal = () => {
    setShowCategoryModal(false);
  };

  useEffect(() => {
    if (categories && !selectedDonorCategoryId) {
      const defaultCategoryId = categories.find(
        category => category.is_default
      )?.id;
      if (defaultCategoryId) {
        setDonorCategoryId(defaultCategoryId);
      }
    }
  }, [categories, selectedDonorCategoryId, setDonorCategoryId]);

  return (
    <>
      {showCategoryModal && (
        <DonorGroupModal show={showCategoryModal} handleClose={closeModal} />
      )}

      <Card className="mb-3">
        <Card.Header className="d-flex">
          <Card.Title className="fw-medium">Donor Type</Card.Title>
        </Card.Header>
        <Card.Body>
          <Row className="g-3">
            <Col md="6">
              <RHFSelect
                name="donor_category_id"
                label="Donor Group"
                options={donorGroupOptions}
                required
                hasAddOption
                onClickAdd={openModal}
              />
            </Col>

            <Col md={6}>
              <Form.Group controlId="type">
                <Form.Label>
                  Donor Type <span className="text-danger">*</span>
                </Form.Label>
                <ReactSelect
                  value={donorTypesOptions.find(
                    opt => opt.value === selectedDonorType
                  )}
                  onChange={option => setSelectedDonorType(option?.value)}
                  options={donorTypesOptions}
                  classNamePrefix="react-select"
                  menuPlacement="auto"
                  components={{
                    IndicatorSeparator: () => null
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mb-3">
        <Card.Header className="d-flex">
          <Card.Title className="fw-medium">Donor info</Card.Title>
        </Card.Header>

        <Card.Body>
          <Row className="g-3">
            <Col md="6">
              <RHFSelect
                name="title"
                label="Title"
                options={TITLE_OPTIONS}
                required
              />
            </Col>
            <Col md="6">
              {/* <RHFControl
                placeholder={'Username'}
                name="username"
                label="Username"
                required
              /> */}
            </Col>{' '}
            <Col md="6">
              <RHFControl
                name="firstName"
                placeholder="First name"
                label="First name"
                required
              />
            </Col>
            <Col md="6">
              <RHFControl
                name="lastName"
                placeholder="Last name"
                label="Last name"
                required
              />
            </Col>
            <Col md="6">
              <RHFSelect
                name="account_manager_id"
                label="Account Manager"
                options={staffOptions}
                noOptional={true}
                isClearable={true}
              />
            </Col>
            {selectedDonorType === 'organisation' && (
              <>
                <Col md="6">
                  <RHFControl
                    name="partner_name"
                    placeholder="Company Name"
                    label="Company Name"
                  />
                </Col>
                <Col md="6">
                  <RHFControl
                    name="job_title"
                    placeholder="Job Title"
                    label="Job Title"
                  />
                </Col>
                <Col md="6">
                  <RHFControl
                    name="charity_registration_number"
                    placeholder="Charity Registration Number"
                    label="Charity Registration No"
                  />
                </Col>
                <Col md="6">
                  <RHFControl
                    name="website"
                    placeholder="Website Link"
                    label="Website Link"
                  />
                </Col>
              </>
            )}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

NameInputs.propTypes = {
  selectedDonorCategoryId: PropTypes.string,
  setDonorCategoryId: PropTypes.func,
  selectedDonorType: PropTypes.string,
  setSelectedDonorType: PropTypes.func
};
export default NameInputs;
